var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepfavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0036 12.9998V15.0007C22.0036 16.6582 20.6599 18.0019 19.0023 18.0019H6.99734C5.3398 18.0019 3.99609 16.6582 3.99609 15.0007V6.99734C3.99609 5.3398 5.3398 3.99609 6.99734 3.99609H9.99859",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0254 7.91797V10.2461C15.0253 10.7575 15.3142 11.225 15.7717 11.4536L16.2939 11.7147C17.0541 12.0946 17.9487 12.0946 18.7089 11.7147L19.2311 11.4536C19.6886 11.225 19.9776 10.7575 19.9775 10.2461V7.91797",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.415 7.1113L16.5012 8.65294C17.1326 8.96789 17.8753 8.96789 18.5067 8.65294L21.5899 7.1113C21.8433 6.98494 22.0034 6.72614 22.0034 6.44298C22.0034 6.15982 21.8433 5.90101 21.5899 5.77466L18.5007 4.23301C17.8695 3.91712 17.1264 3.91712 16.4952 4.23301L13.412 5.77466C13.1589 5.90159 12.9994 6.16075 13 6.44391C13.0006 6.72707 13.1614 6.98551 13.415 7.1113Z",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0041 6.44336V8.24411",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 18.002L15.5013 22.0036",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 18.002L10.4991 22.0036",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19824 22.0022H17.8022",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepfavicon);
export default __webpack_public_path__ + "static/media/stepfavicon.d6c799bbb667f209c32a4310124c1fdd.svg";
export { ForwardRef as ReactComponent };